import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RepeatOneOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"repeat_one_on"}/>
}
